import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { FunctionalType } from '../models/blockedFunctionalType';
import { IInfoModalData } from '../modals/info-modal/models/infoModalData';
import { MixpanelEvents } from '../models/mixpanelEvents';
import { PlatformApplications } from '../models/platformApplications';
import { TYPES_SETTINGS } from '../models/blockedFunctionalSettings';

import { InfoModalComponent } from '../modals/info-modal/info-modal.component';

import { MixpanelService } from './mixpanel.service';
import { SessionService } from './session.service';

@Injectable({
	providedIn: 'root'
})
export class BlockedFunctionalService {

	private _modalOpened: boolean = false;

	constructor(
		private dialog: MatDialog,
		private translate: TranslateService,
		private mixpanelService: MixpanelService,
		private sessionService: SessionService
	) {}

	openBlockedFunctionalModal(type: FunctionalType): void {
		if (this._modalOpened) return;

		this._modalOpened = true;
		this.mixpanelService.trackPage(MixpanelEvents.BlockedFunctionalPage, { type: type });
		this.sessionService.getAvailableTariff(TYPES_SETTINGS[type].feature)
			.subscribe((result: { id: number, name: string }) => {
				const NAMES: { [key: string]: string } = {
					LITE: 'Lite',
					STARTER: 'Starter',
					PRO: 'Pro',
					ENTERPRISE: 'Enterprise'
				};
				let functionalType: string;
				this.translate
					.get('INFO_MODAL.USE_IN_TARIFF', { tariff: NAMES[result.name] })
					.subscribe((text: string) => functionalType = text);

				this.dialog
					.open<InfoModalComponent, IInfoModalData<InfoModalComponent>>(InfoModalComponent, {
						width: '60vw',
						height: '80vh',
						autoFocus: false,
						backdropClass: 'back-drop',
						panelClass: 'full-width-modal-actions',
						data: {
							media: TYPES_SETTINGS[type].mediaUrl,
							mediaType: 'image',
							type: functionalType,
							title: TYPES_SETTINGS[type].title,
							description: TYPES_SETTINGS[type].description,
							secondaryButtonText: 'GO_BACK',
							secondaryButtonCallback: (ref: MatDialogRef<InfoModalComponent>) => {
								ref.close();
							},
							primaryButtonText: 'COMMON.CHOOSE_TARIFF',
							primaryButtonCallback: (ref: MatDialogRef<InfoModalComponent>) => {
								this.mixpanelService.trackPage(MixpanelEvents.ChooseTariff, { page: 'Blocked functional' });
								window.open(
									this.sessionService.getExternalLink(PlatformApplications.AdminPanel, '/tariff-plans'),
									'_blank'
								);
								ref.close();
							}
						}
					})
					.afterClosed()
					.subscribe(() => this._modalOpened = false);
			});
	}
}